<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab :title="title" active>
                <b-card-text>
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-row>
                            <b-col
                                v-for="(d_item, i) in dataItems"
                                :key="i + 'data'"
                                :cols="d_item.cols"
                            >
                                <b-form-group
                                    :id="d_item.field"
                                    :label="getLabel(d_item.field)"
                                    :label-for="'input-' + d_item.field"
                                    label-cols="3"
                                    v-if="checkVisibility(d_item)"
                                >
                                    <selection-values
                                        v-if="
                                            d_item.field === 'value_selections'
                                        "
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :name="'input-' + d_item.field"
                                        :disabled="isView"
                                    >
                                    </selection-values>

                                    <default-value
                                        v-else-if="
                                            d_item.field === 'default_value'
                                        "
                                        :is-selection-value-type="
                                            !!model.is_selection_value_type
                                        "
                                        :values="model.value_selections"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :disabled="isView"
                                        :min="model.value_min"
                                        :max="model.value_max"
                                    />

                                    <b-form-checkbox
                                        v-else-if="d_item.type === 'boolean'"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :name="'input-' + d_item.field"
                                        :value="1"
                                        :unchecked-value="0"
                                        :disabled="isView"
                                    >
                                    </b-form-checkbox>

                                    <b-form-select
                                        v-else-if="d_item.type === 'select'"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :options="getOptions(d_item.field)"
                                        :disabled="isView"
                                    >
                                        <template #first>
                                            <b-form-select-option
                                                :value="null"
                                                disabled
                                                >{{
                                                    'Select ' +
                                                    getLabel(d_item.field)
                                                }}</b-form-select-option
                                            >
                                        </template>
                                    </b-form-select>
                                    <b-form-input
                                        v-else
                                        :disabled="isView"
                                        :type="d_item.type"
                                        :id="'input-' + d_item.field"
                                        v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        :placeholder="
                                            'Enter ' + getLabel(d_item.field)
                                        "
                                        trim
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col offset="5">
                                <b-button
                                    variant="secondary"
                                    :disabled="!!submitting"
                                    @click="cancel()"
                                    size="sm"
                                    >Cancel</b-button
                                >
                                <b-button
                                    v-if="
                                        !!model.id &&
                                        user_permissions.some(r =>
                                            [
                                                'create.master.items',
                                                'update.master.items',
                                                'delete.master.items',
                                            ].includes(r)
                                        )
                                    "
                                    variant="primary"
                                    :disabled="!!submitting"
                                    @click="isView = !isView"
                                    size="sm"
                                    >{{ isView ? 'Edit' : 'View' }}</b-button
                                >
                                <b-button
                                    v-if="
                                        model.id == 0 &&
                                        !isView &&
                                        user_permissions.includes(
                                            'create.master.items'
                                        )
                                    "
                                    variant="primary"
                                    :disabled="!!submitting"
                                    type="submit"
                                    size="sm"
                                >
                                    <b-spinner
                                        v-show="submitting"
                                        label="Spinning"
                                    ></b-spinner>
                                    Create Item
                                </b-button>

                                <b-button
                                    v-if="
                                        model.id > 0 &&
                                        !isView &&
                                        user_permissions.includes(
                                            'update.master.items'
                                        )
                                    "
                                    variant="primary"
                                    :disabled="!!submitting"
                                    type="submit"
                                    size="sm"
                                >
                                    <b-spinner
                                        v-show="submitting"
                                        label="Spinning"
                                    ></b-spinner>
                                    Update Item
                                </b-button>

                                <b-button
                                    v-if="
                                        model.id > 0 &&
                                        !isView &&
                                        user_permissions.includes(
                                            'delete.master.items'
                                        )
                                    "
                                    @click="deleteMasterItem()"
                                    variant="warning"
                                    size="sm"
                                >
                                    Delete Item
                                </b-button>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card-text>
            </b-tab>
            <b-tab title="Inventory">
                <b-card-body>
                    <ItemInventory :master_item_id="id" />
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
//import ViewItem from './ViewItem'
//ext_reference_code, name, description, uom, selling_price, active, vendor_id, order_item_type_id
//ext_reference_code, name, description, uom, selling_price, active, vendor_id, order_item_type_id
const dataItems = [
    { field: 'name', type: 'text', required: true, cols: '12' },
    { field: 'ext_reference_code', type: 'text', required: false, cols: '12' },
    { field: 'order_item_type_id', type: 'select', required: true, cols: '12' },
    { field: 'description', type: 'text', required: false, cols: '12' },
    { field: 'vendor_id', type: 'select', required: true, cols: '12' },
    { field: 'uom', type: 'text', cols: '12' },
    { field: 'selling_price', type: 'text', required: true, cols: '12' },

    {
        field: 'is_selection_value_type',
        type: 'boolean',
        required: false,
        cols: '12',
    },
    { field: 'value_name', type: 'text', required: false, cols: '12' },
    { field: 'value_max', type: 'number', required: false, cols: '12' },
    { field: 'value_min', type: 'number', required: false, cols: '12' },
    { field: 'value_selections', type: 'custom', required: false, cols: '12' },
    { field: 'default_value', type: 'custom', required: false, cols: '12' },
    { field: 'active', type: 'boolean', cols: '12' },
]

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = null
            return _form
        },
        { id: 0 }
    )
}

import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import SelectionValues from './SelectionValues.vue'
import DefaultValue from './DefaultValue.vue'
import ItemInventory from './ItemInventory.vue'

const model = generateEmptyForm()
export default {
    name: 'ViewItem',
    components: {
        SelectionValues,
        DefaultValue,
        ItemInventory,
    },
    mixins: [popupMixins, utilityMixins],
    props: ['id'],
    data() {
        return {
            dataItems,
            model,
            submitting: false,
            hasErrors: false,
            isView: false,
        }
    },

    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        selectionOptions() {
            const { value_selections } = this.model
            try {
                return JSON.parse(value_selections)
            } catch (err) {
                return []
            }
        },
        title() {
            return this.isView
                ? 'Selected Item'
                : this.id
                ? 'Edit Item'
                : 'Add Item'
        },
        item() {
            return this.$store.state.masterItem.item
        },

        vendors() {
            return this.$store.state.assets.vendors
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        'model.order_item_type_id': function (id) {
            const type = this.types.find(x => x.id === id)
            console.log('type', type)
            if (type) model.uom = type.uom
        },
    },
    created() {
        this.isView = !!this.id
    },
    async mounted() {
        const { id } = this
        console.log('id', id)
        this.model = generateEmptyForm()
        if (id) {
            this.loading = true
            this.isView = true
            try {
                await this.$store.dispatch('locations/fetchWarehouses')
                await this.$store.dispatch('masterItem/fetchById', id)
                await this.$nextTick()
                const _item = { ...this.item }
                if (_item.value_selections) {
                    _item.value_selections = JSON.parse(_item.value_selections)
                } else {
                    _item.value_selections = []
                }
                this.model = Object.keys(_item).reduce((_model, key) => {
                    _model[key] = _item[key]
                    return _model
                }, {})
            } catch (error) {
                console.error(error)
                this.isError = true
            } finally {
                this.loading = false
            }
        }
        console.log('mounted model', this.model)
    },
    methods: {
        checkVisibility(item) {
            switch (item.field) {
                case 'value_selections':
                    return !!this.model.is_selection_value_type
                case 'value_min':
                case 'value_max':
                    return !this.model.is_selection_value_type
                default:
                    return true
            }
        },
        getLabel(field) {
            if (field === 'order_item_type_id') return 'Type'
            if (field === 'ext_reference_code') return 'Reference Code'
            const list = field.split('_')
            ///remove last item if equal to id
            if (list[list.length - 1] === 'id') {
                list.pop()
            }
            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getOptions(field) {
            const arr = (() => {
                switch (field) {
                    case 'vendor_id':
                        return this.vendors || []
                    case 'order_item_type_id':
                        return this.types || []
                }
            })()

            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        cancel() {
            this.$router.go(-1)
        },
        async deleteMasterItem() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/master-items',
                deleteRoute: 'masterItem/delete',
            }
            const notificationFields = {
                type: 'Master Item',
                errorMsg:
                    'Unable to delete Master Item, an association exists with other records',
            }

            await this.deleteItem(notificationFields, model, routes)
        },
        async onSubmit() {
            const valid = await this.$validator.validate()
            if (valid) {
                try {
                    //check default valye
                    const payload = { ...this.model }
                    if (!payload.is_selection_value_type) {
                        const value = parseFloat(payload.default_value)
                        console.log('value-------', value)
                        if (isNaN(value)) {
                            throw new Error('Invalid Default Value--0')
                        }
                        const max = parseFloat(payload.value_max)
                        console.log('max', max)
                        if (value > max) {
                            throw new Error('Invalid Default Value--1')
                        }

                        const min = parseFloat(payload.value_min)
                        console.log('min', min)
                        if (value < min) {
                            throw new Error('Invalid Default Value---2')
                        }
                    }

                    payload.value_selections = JSON.stringify(
                        payload.value_selections
                    )

                    const isEdit = !!parseInt(payload.id)
                    const path = `masterItem/${isEdit ? 'update' : 'create'}`

                    this.submitting = true
                    await this.$store.dispatch(path, payload)
                    this.model = generateEmptyForm()
                    const message = `Item ${isEdit ? 'Updated' : 'Created'}`
                    this.$emit('success', message)
                    this.$router.go(-1)
                } catch (error) {
                    this.doToast('Error Detected', error.message, 'warning')
                } finally {
                    this.submitting = false
                }
            }
        },
    },
}
</script>
<style></style>
